import { Avatar, type AvatarSize } from "./Avatar.tsx"

export type UserAvatarProps = {
  url?: string
  name: string
  size: AvatarSize
}

export const UserAvatar = ({ url, name, size }: UserAvatarProps) => {
  return <Avatar src={url} kind="circle" size={size} displayName={name} />
}
